import { render, staticRenderFns } from "./ModalLevelComplete.vue?vue&type=template&id=f536873c&"
import script from "./ModalLevelComplete.vue?vue&type=script&lang=js&"
export * from "./ModalLevelComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports